import './headerContent.scss';
//import Car from '../../assets/image/img/car.png';
//import CarBg from '../../assets/image/img/carbg.png';
import CarVideo from '../../assets/video/bg.mp4'
import { useTranslation } from 'react-i18next';

function HeaderContent() {
    const { t } = useTranslation();

    return (
        <div className="header-content__container">
            <video autoPlay loop muted playsInline className="header-content__video">
                <source src={CarVideo} type="video/mp4" />
            </video>
            <div className="header-content__group">
                <div className="header-content__overlap-group">
                    
                </div>
            </div>
            <div className="header-content__text">
                <h1>{t('safe_transport')}</h1>
                <p>{t('our_goal')}</p>
            </div>
        </div>
    );
}

export default HeaderContent;